module.exports = __webpack_public_path__ + "img/DAVID_CANNON_16-rs.1624b0ff.jpg";